import { observer } from 'mobx-react';
import * as React from 'react';
import { ExperienceResource } from '../../../../../../../Types';
import LearningDesignExperienceStore from '../../../../../../Experience/Store';
import DateCount from './DateCount';
import DateList from './DateList';
import PopoverContent from './PopoverContent';
import Popover from '../../../../Popover';

interface Props {
  experienceResource: ExperienceResource;
  experienceStore: LearningDesignExperienceStore;
}

const filteredInstances = (
  experienceResource: ExperienceResource,
  experienceStore: LearningDesignExperienceStore,
) =>
  experienceResource.payload.programInstanceOptions.scheduled.filter((instance) =>
    experienceStore.selectedIds.includes(instance.id),
  );

const DatePopover: React.FC<Props> = ({ experienceResource, experienceStore }) => (
  <Popover
    icon={
      <p className="underline decoration-teal-600 decoration-dashed mx-2">
        <DateCount optionsLength={filteredInstances(experienceResource, experienceStore).length} />
      </p>
    }
    content={
      <PopoverContent
        content={<DateList instances={filteredInstances(experienceResource, experienceStore)} />}
      />
    }
  />
);

export default observer(DatePopover);
